import { BusinessReportPage } from "@/features/business-report";

const BusinessReport = () => {
  return <BusinessReportPage />;
};

export default BusinessReport;
